export default "__VITE_ASSET__e107ea3b__"